// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sk-chase {
  width: 70px;
  height: 70px;
  position: relative;
  animation: sk-chase 2.5s infinite linear both;
}

.sk-chase-dot {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  animation: sk-chase-dot 2s infinite ease-in-out both;
}

.sk-chase-dot:before {
  content: "";
  display: block;
  width: 25%;
  height: 25%;
  background-color: #23b7e5;
  border-radius: 100%;
  animation: sk-chase-dot-before 2s infinite ease-in-out both;
}

.sk-chase-dot:nth-child(1) {
  animation-delay: -1.1s;
}

.sk-chase-dot:nth-child(2) {
  animation-delay: -1s;
}

.sk-chase-dot:nth-child(3) {
  animation-delay: -0.9s;
}

.sk-chase-dot:nth-child(4) {
  animation-delay: -0.8s;
}

.sk-chase-dot:nth-child(5) {
  animation-delay: -0.7s;
}

.sk-chase-dot:nth-child(6) {
  animation-delay: -0.6s;
}

.sk-chase-dot:nth-child(1):before {
  animation-delay: -1.1s;
}

.sk-chase-dot:nth-child(2):before {
  animation-delay: -1s;
}

.sk-chase-dot:nth-child(3):before {
  animation-delay: -0.9s;
}

.sk-chase-dot:nth-child(4):before {
  animation-delay: -0.8s;
}

.sk-chase-dot:nth-child(5):before {
  animation-delay: -0.7s;
}

.sk-chase-dot:nth-child(6):before {
  animation-delay: -0.6s;
}

@keyframes sk-chase {
  100% {
    transform: rotate(360deg);
  }
}
@keyframes sk-chase-dot {
  80%, 100% {
    transform: rotate(360deg);
  }
}
@keyframes sk-chase-dot-before {
  50% {
    transform: scale(0.4);
  }
  100%, 0% {
    transform: scale(1);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/spinners/chase/chase.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,6CAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,oDAAA;AACF;;AAEA;EACE,WAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,2DAAA;AACF;;AAEA;EACE,sBAAA;AACF;;AAEA;EACE,oBAAA;AACF;;AAEA;EACE,sBAAA;AACF;;AAEA;EACE,sBAAA;AACF;;AAEA;EACE,sBAAA;AACF;;AAEA;EACE,sBAAA;AACF;;AAEA;EACE,sBAAA;AACF;;AAEA;EACE,oBAAA;AACF;;AAEA;EACE,sBAAA;AACF;;AAEA;EACE,sBAAA;AACF;;AAEA;EACE,sBAAA;AACF;;AAEA;EACE,sBAAA;AACF;;AAEA;EACE;IACE,yBAAA;EACF;AACF;AAEA;EACE;IACE,yBAAA;EAAF;AACF;AAGA;EACE;IACE,qBAAA;EADF;EAGA;IACE,mBAAA;EADF;AACF","sourcesContent":[".sk-chase {\n  width: 70px;\n  height: 70px;\n  position: relative;\n  animation: sk-chase 2.5s infinite linear both;\n}\n\n.sk-chase-dot {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  left: 0;\n  top: 0;\n  animation: sk-chase-dot 2.0s infinite ease-in-out both;\n}\n\n.sk-chase-dot:before {\n  content: '';\n  display: block;\n  width: 25%;\n  height: 25%;\n  background-color: #23b7e5;\n  border-radius: 100%;\n  animation: sk-chase-dot-before 2.0s infinite ease-in-out both;\n}\n\n.sk-chase-dot:nth-child(1) {\n  animation-delay: -1.1s;\n}\n\n.sk-chase-dot:nth-child(2) {\n  animation-delay: -1.0s;\n}\n\n.sk-chase-dot:nth-child(3) {\n  animation-delay: -0.9s;\n}\n\n.sk-chase-dot:nth-child(4) {\n  animation-delay: -0.8s;\n}\n\n.sk-chase-dot:nth-child(5) {\n  animation-delay: -0.7s;\n}\n\n.sk-chase-dot:nth-child(6) {\n  animation-delay: -0.6s;\n}\n\n.sk-chase-dot:nth-child(1):before {\n  animation-delay: -1.1s;\n}\n\n.sk-chase-dot:nth-child(2):before {\n  animation-delay: -1.0s;\n}\n\n.sk-chase-dot:nth-child(3):before {\n  animation-delay: -0.9s;\n}\n\n.sk-chase-dot:nth-child(4):before {\n  animation-delay: -0.8s;\n}\n\n.sk-chase-dot:nth-child(5):before {\n  animation-delay: -0.7s;\n}\n\n.sk-chase-dot:nth-child(6):before {\n  animation-delay: -0.6s;\n}\n\n@keyframes sk-chase {\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes sk-chase-dot {\n  80%, 100% {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes sk-chase-dot-before {\n  50% {\n    transform: scale(0.4);\n  }\n  100%, 0% {\n    transform: scale(1.0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
